import { gql } from '@soundxyz/gql-string';
import { useAuth } from '@context/auth/base';
import { RefetchOperationsOnComplete } from '@graphql/helpers/effects';
import {
  ClientNftUpsertDocument,
  LastOwnedReleaseNftDocument,
  useQuery,
} from '@graphql/reactQuery';

/*#__PURE__*/ gql(/* GraphQL */ `
  query LastOwnedReleaseNft($userId: UUID!, $releaseId: UUID!) {
    user(id: $userId) {
      id
      nftsPaginated(
        pagination: { first: 1, sort: { secondarySaleDate: DESC } }
        filter: { releases: [$releaseId] }
      ) {
        edges {
          node {
            id
            comment {
              id
              message
            }
            songSlot
          }
        }
      }
    }
  }
`);

RefetchOperationsOnComplete({
  trigger: [ClientNftUpsertDocument],
  refetch: [LastOwnedReleaseNftDocument],
});

export function useNftOwnershipData({ releaseId }: { releaseId: string }) {
  const { authUser } = useAuth();

  const {
    data,
    isFetching: tokensOwnedByUserLoading,
    refetch: refetchOwnedNft,
  } = useQuery(LastOwnedReleaseNftDocument, {
    variables: !!releaseId &&
      !!authUser && {
        releaseId,
        userId: authUser.id,
      },
    staleTime: 0,
  });

  const activeNft = data?.data.user?.nftsPaginated.edges[0]?.node;

  return {
    tokensOwnedByUserLoading,
    isReleaseOwner: activeNft != null,
    currentComment: activeNft?.comment?.message || '',
    hasPickedTimeslot: activeNft?.songSlot !== null && activeNft?.songSlot !== undefined,
    nftOwnedByUser: activeNft,
    refetchOwnedNft,
  };
}
